import { useState, type ReactNode } from 'react';

import '@/components/shared/upload-inline.css';

/** `C` est le nom du champ : le `setValue` appelant doit accepter un `File` pour ce champ. */
export interface UploadInlineProps<C extends string = string> {
    setValue: (name: C, file: File) => void;
    label?: ReactNode;
    /** Nom du champ de formulaire qui reçoit le fichier. */
    code: C;
    /** Fichier courant du formulaire : son absence (formulaire réinitialisé) efface le nom affiché. */
    file?: File | null;
    isForm?: boolean;
    required?: boolean;
}

const UploadInline = <C extends string>(props: UploadInlineProps<C>) => {
    const { setValue, label, code, file, isForm, required } = props;
    const [name, setName] = useState<string | null>(null);

    const handleChange = (file?: File) => {
        if (file) {
            setName(file.name);
            setValue(code, file);
        }
    };

    if (isForm && !file && name) setName(null);

    return (
        <div className={'form-group'}>
            {label && <label>{label}{required ? <sup className={'text-destructive'} aria-label="obligatoire">*</sup> : ''}</label> }
            <div className="relative">
                <input required={required} id="file" type="file" accept="image/*,application/pdf" className="custom-file-input" onChange={(e) => handleChange(e.target.files?.[0])}/>
                <label htmlFor={"file"} className={`${name ? 'valid' : ''} custom-file-label overflow-hidden w-full cursor-pointer`} style={{height: 55, paddingTop: 14, border: '1px solid black'}}>{`${name || 'Choisissez un fichier...'}`}</label>
            </div>
            <p className="text-xs text-muted-foreground mt-1">Format des fichiers autorisés : PDF, JPG, PNG</p>
        </div>
    );
};

export default UploadInline;
